import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  connect() {
    // Small delay to ensure page is fully loaded
    setTimeout(() => {
      this.submitTarget.click()
    }, 100)
  }
}
